import { resolvePublicLpReturnTo } from "./publicLpReturn";
import { readRouteStateReturnTo } from "./appHeaderRoutes";

export type PlansLocationState = {
  from?: unknown;
  returnTo?: unknown;
};

const AUTH_ENTRY_PATHS = new Set(["/", "/login", "/splash", "/register", "/start"]);
const PROTECTED_ENTRY_PREFIXES = [
  "/home",
  "/talk",
  "/request",
  "/chat",
  "/profile",
  "/character-switch",
  "/receipt",
  "/executive-memos",
];

function isProtectedEntryPath(path: string): boolean {
  return PROTECTED_ENTRY_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
}

export function resolvePlansReturnPath(
  state: PlansLocationState | null,
  isAuthenticated: boolean,
  search: string
): string {
  const publicLpReturnTo = resolvePublicLpReturnTo(new URLSearchParams(search).get("returnTo"));
  if (publicLpReturnTo) return publicLpReturnTo;

  const explicitPath = readRouteStateReturnTo({ returnTo: state?.returnTo })
    ?? readRouteStateReturnTo({ returnTo: state?.from });

  if (explicitPath) {
    if (isAuthenticated && AUTH_ENTRY_PATHS.has(explicitPath)) {
      return "/home";
    }
    if (!isAuthenticated && isProtectedEntryPath(explicitPath)) {
      return "/";
    }
    return explicitPath;
  }

  return isAuthenticated ? "/home" : "/";
}
